module.exports = __webpack_public_path__ + "images/img-2cc48Zy.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/en/11.png
// module id = 2335
// module chunks = 0